import React, { useState, useEffect } from "react";
import { fetchLayoffsByYear } from "../utils/airtable"; // Adjust path if needed
import "./AttackSummary.css"; // Import the CSS file

const AttackSummary = () => {
    const [year, setYear] = useState(2026);
    const [data, setData] = useState({ totalKilled: 0, totalInjured: 0, totalAttacks: 0 });

    useEffect(() => {
        fetchLayoffsByYear(year).then(setData).catch(console.error);
    }, [year]); // Re-fetch when year changes

    return (
        <div className="attack-summary">
            <p>
                <strong>{data.totalAttacks.toLocaleString()}</strong> attacks,{" "}
                <strong>{data.totalKilled.toLocaleString()}</strong> people killed and{" "}
                <strong>{data.totalInjured.toLocaleString()}</strong> injured in{" "}
                <select
                    id="year-select"
                    value={year}
                    onChange={(e) => setYear(parseInt(e.target.value))}
                >
                    {[...Array(11)].map((_, i) => {
                        const y = 2026 - i;
                        return <option key={y} value={y}>{y}</option>;
                    })}
                </select>
            </p>
        </div>
    );
};

export default AttackSummary;
